module.exports = __webpack_public_path__ + "img/cdq1b32-01.prt.0f08b340.jpg";